import { uiBase } from '../../env/constants'

export const aboutURL   = uiBase +'about'
export const legalURL   = uiBase +'legal'
export const privacyURL = uiBase +'privacy'
export const termsURL   = uiBase +'terms'
